import { useEffect, useRef } from 'react';
import './custom-styles.css';

export const ScrollIndicator = () => {
    const scrollIndicatorRef = useRef<HTMLDivElement | null>(null);

    function hideScrollIndicator() {
        if (!scrollIndicatorRef.current) return;
        if (window.scrollY > 10) {
            scrollIndicatorRef.current.style.opacity = '0';
        } else {
            scrollIndicatorRef.current.style.opacity = '1';
        }
    }

    useEffect(() => {
        addEventListener('scroll', hideScrollIndicator);

        return () => {
            removeEventListener('scroll', hideScrollIndicator);
        }
    }, []);

    return (
        <div ref={scrollIndicatorRef} className="scroll-indicator transition-opacity fixed bottom-1 left-1/2 -translate-1/2 w-1/12 max-w-8 aspect-square rotate-270">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.402 197.402" id="topArrow" className="">
                <polygon points="146.883,197.402 45.255,98.698 146.883,0 152.148,5.418 56.109,98.698 152.148,191.98"/>
            </svg>
        </div>
    );
}